<template>
  <div class="header">
    <div class="containr clearfix">
      <div class="logo fl">
        <router-link :to="{path: '/'}">
          <img src="../assets/img/logo.png" srcset="../assets/img/logo@2x.png 2x">
        </router-link>
      </div>
      <div class="langBox fr" @mouseleave="showLangList = false">
        <div @click.stop="showLangList = !showLangList" class="langBtn">
          <span v-if="$i18n.locale == 'en'">EN</span>
          <span v-if="$i18n.locale == 'zh'">中文</span>
          <span v-if="$i18n.locale == 'ko'">한글</span>
          <span v-if="$i18n.locale == 'vi'">tiếng Việt</span>
          <span v-if="$i18n.locale == 'id'">Bahasa ID</span>
        </div>
        <div v-show="showLangList" class="langList">
          <div class="whiteBg">
            <div class="langItem" v-show="!($i18n.locale == 'en')" @click="changeLang('en')">EN</div>
            <!-- <div class="langItem" v-show="!($i18n.locale == 'zh')" @click="changeLang('zh')">中文</div> -->
            <div class="langItem" v-show="!($i18n.locale == 'ko')" @click="changeLang('ko')">한글</div>
            <div class="langItem" v-show="!($i18n.locale == 'vi')" @click="changeLang('vi')">tiếng Việt</div>
            <div class="langItem" v-show="!($i18n.locale == 'id')" @click="changeLang('id')">Bahasa ID</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../bus'
export default {
  data () {
    return {
      showLangList: false
    }
  },
  created () {
    Bus.$on('hideLangList', (Bool) => {
      this.showLangList = Bool
    })
  },
  methods: {
    changeLang (lang) {
      this.$i18n.locale = lang
      this.showLangList = false
    },
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>
<style lang="less" scoped>
.header{
  width: 100%;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  .containr{
    padding-left: 80px;
    padding-right: 80px;
    .logo{
      width: 83px;
      padding-top: 22px;
    }
    .langBox{
      position: relative;
      margin-top: 31px;
      .langBtn{
        span{
          cursor: pointer;
          font-size: 16px;
          font-family: Montserrat-SemiBold, Montserrat;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 19px;
        }
      }
      .langList{
        position: absolute;
        top: 19px;
        right: 0;
        padding-top: 20px;
        .whiteBg{
          width: 160px;
          background: #FFFFFF;
          box-shadow: 0px 16px 40px 0px rgba(51, 61, 70, 0.2);
          text-align: center;
          padding-top: 20px;
          padding-bottom: 1px;
          .langItem{
            font-size: 16px;
            font-family: Montserrat-SemiBold, Montserrat;
            font-weight: 600;
            color: #333D46;
            line-height: 19px;
            margin-bottom: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (max-width:760px){
  .header{
    .containr{
      padding-left: 20px;
      padding-right: 20px;
      .logo{
        width: 60px;
        padding-top: 15px;
      }
      .langBox{
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue